module.exports = __webpack_public_path__ + "static/img/hnweR410A.a21edcf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productList/internationalBrand/hnweR410A.jpg
// module id = Fyiq
// module chunks = 1